import axios from 'axios';
export default (id, payload) => {
  const promise = new Promise((resolve, reject) => {
    axios.post(process.env.VUE_APP_API_ADMIN_LOCATION + `/providers/${id}/pay-transactions`, payload).then(
      () => {
        resolve(true);
      },
      (error) => {
        reject(error);
      }
    );
  });

  return promise;
};
